import { RouteResolver } from '@/core/types/route-resolver';
import { NavigationGuardNext, Route } from 'vue-router';

export const resolveRoute = ({
	pre,
	post,
	resolvers,
	errorHandler,
}: {
	pre?: any;
	post?: any;
	resolvers: RouteResolver[];
	errorHandler?: any;
}) => async (to: Route, from: Route, next: NavigationGuardNext): Promise<any> => {
	try {
		if (pre) {
			await pre();
		}

		await Promise.all(resolvers.map((resolver) => resolver(to, from, next)));

		next();

		if (post) {
			await post();
		}
	} catch (error) {
		if (errorHandler) {
			errorHandler(error);
		} else {
			console.error(error);
		}
	}
};
